import api from './api';
import qs from 'qs';

export interface ICreatePreSignUrl {
  type: 'USER_PICTURE' | 'GROUP_COVER' | 'LEAGUE_LOGO' | 'LEVEL_ICON'
  name: string
  isPublic: boolean
  isPaid?: boolean
  price?: number
}

export const createPreSignedUrl = async (config: ICreatePreSignUrl) => {
  const preSignedData = await api.post('files/presigned-url', { data: config });
  
  return preSignedData.data;
}

export const deleteImage = async (id: string) => {
  const preSignedData = await api.deleteApi(`files/${id}`);
  
  return preSignedData.data;
}

export const getImagesList = async (props?: any) => {
  const imagesData = await api.get(`files?${qs.stringify(props)}`);
  
  return imagesData.data;
}